import { useReducer, useCallback } from "react";
import type { ViewspecState } from "../viewspecs/types.ts";
import { DEFAULT_VIEWSPECS } from "../viewspecs/types.ts";
import { parseViewspecCodes } from "../viewspecs/codes.ts";

type ViewspecAction =
  | { type: "set"; payload: Partial<ViewspecState> }
  | { type: "reset" }
  | { type: "codes"; payload: string };

function viewspecReducer(
  state: ViewspecState,
  action: ViewspecAction
): ViewspecState {
  switch (action.type) {
    case "set":
      return { ...state, ...action.payload };
    case "reset":
      return { ...DEFAULT_VIEWSPECS };
    case "codes":
      return { ...state, ...parseViewspecCodes(action.payload) };
  }
}

export function useViewspecs(initial?: Partial<ViewspecState>) {
  const [viewspecs, dispatch] = useReducer(viewspecReducer, {
    ...DEFAULT_VIEWSPECS,
    ...initial,
  });

  const setViewspecs = useCallback(
    (vs: Partial<ViewspecState>) => dispatch({ type: "set", payload: vs }),
    []
  );

  const resetViewspecs = useCallback(
    () => dispatch({ type: "reset" }),
    []
  );

  const applyViewspecCodes = useCallback(
    (codes: string) => dispatch({ type: "codes", payload: codes }),
    []
  );

  return {
    viewspecs,
    setViewspecs,
    resetViewspecs,
    applyViewspecCodes,
  };
}
